"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSetSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class StandardSetSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            globalId: data.globalId,
            name: data.name,
            additionalInfo: data.additionalInfo,
            hierarchies: data.hierarchies,
            displayName: data.displayName,
        };
    }
    serializeSubject(data) {
        return {
            id: data.id,
            subject: data.subject,
            subjectProviderId: data.subjectProviderId,
            displayName: data.displayName,
        };
    }
    serializeCourse(data) {
        return {
            id: data.id,
            course: data.name,
            courseProviderId: data.providerId,
        };
    }
    serializeHierarchy(data) {
        return {
            id: data.id,
            ancestor: data.ancestor,
            descendant: data.descendant,
            length: data.length,
            standardSetLevel: data.standardSetLevel,
            standardSetGlobalId: data.standardSetGlobalId,
        };
    }
    serializeHierarchyLevel(data) {
        return {
            standardSetGlobalId: {
                hierarchy: data.ancestor,
            },
        };
    }
    serializeStandardSetSearch(data) {
        const items = data.data.map((st) => {
            return {
                id: st.id,
                globalId: st.globalId,
                displayName: st.displayName,
                codePrefixes: st.codePrefixes,
                additionalInfo: st.additionalInfo,
                type: st.type,
                visibility: st.visibility,
                standardItemsIncomplete: st.standardItemsIncomplete,
                status: st.status,
                standardItemsTotal: st.standardItemsTotal,
                standardItemsPending: st.standardItemsPending,
            };
        });
        const pagination = {
            page: data.meta.page,
            limit: data.meta.limit,
            itemsCount: data.meta.itemsCount,
            pagesCount: data.meta.pagesCount,
            hasPreviousPage: data.meta.hasPreviousPage,
            hasNextPage: data.meta.hasNextPage,
        };
        return { data: items, meta: pagination };
    }
}
exports.StandardSetSerializer = StandardSetSerializer;
//# sourceMappingURL=standard-set.serializer.js.map